<script lang="ts">
  // BJL-CHECK: Card (used), Button (considered). The transparent full-card open target stays
  // native because a styled Button cannot sit behind the independent remove action.
  import { Card } from '@byjackli-labs/ui/Card'
  import { Colors } from '../../ui/colors'
  import { Type } from '../../ui/theme'
  import RemoveButton from './RemoveButton.svelte'
  import type { Snippet } from 'svelte'

  interface Props {
    title: string
    onRemove: () => void
    onOpen: () => void
    badges: Snippet
    trailing: Snippet
    marginBottom?: number
  }

  const { title, onRemove, onOpen, badges, trailing, marginBottom = 12 }: Props = $props()
</script>

<div style="position: relative; margin-bottom: {marginBottom}px;">
  <button
    type="button"
    onclick={onOpen}
    aria-label="Open {title}"
    style="
      position: absolute; inset: 0; z-index: 0;
      background: none; border: none; padding: 0; margin: 0;
      cursor: pointer;
    "
  ></button>
  <RemoveButton {onRemove} top={8} right={8} />
  <Card>
    <div style="display: flex; align-items: center; gap: 10px;">
      <div style="flex: 1; min-width: 0; padding-right: 18px;">
        <div
          style="
            color: {Colors.text}; {Type.title};
            overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
          "
        >{title}</div>
        <div style="display: flex; gap: 5px; margin-top: 6px; flex-wrap: wrap;">
          {@render badges()}
        </div>
      </div>
      <div style="text-align: right; flex-shrink: 0;">
        {@render trailing()}
      </div>
    </div>
  </Card>
</div>
